import { CountryCode } from '@quromedical/fhir-common';
import {
  AlternatePhoneNumberSchema,
  type PersonContact,
  type PersonGeneral,
  PrimaryPhoneNumberSchema,
} from '@quromedical/models';
import type { Field } from 'components/types';
import {
  createPersonContactFields,
  genderRow,
  nameRow,
  prefixRow,
} from 'core/forms';
import type { Fetcher } from 'design-system';

/**
 * Stub type for merging person data into a single object
 */
export type JointFields = PersonGeneral &
  Omit<PersonContact, 'addressCoordinates'>;

/**
 * Get the resolved contact form fields based on the current form state
 */
export const resolveFormNextOfKinFields = (
  formState: Partial<PersonContact>,
  addressFetcher?: Fetcher<string>,
): Field<JointFields>[] => {
  const isPrimaryValid = PrimaryPhoneNumberSchema.safeParse(
    formState.telecomPhoneNumbers?.[0],
  ).success;

  // the secondary number may be empty or match the required format
  const isSecondaryEmpty = !formState.telecomPhoneNumbers?.[1];

  const isSecondaryValid =
    isSecondaryEmpty ||
    AlternatePhoneNumberSchema.safeParse(formState.telecomPhoneNumbers?.[1])
      .success;

  const contactDetailsRows = createPersonContactFields(
    isPrimaryValid,
    isSecondaryValid,
    addressFetcher,
  );
  return [prefixRow, nameRow, genderRow, ...contactDetailsRows];
};

export const initialNextOfKin: Partial<JointFields> = {
  telecomPhoneNumbers: ['', ''],
  addressLines: ['', ''],
  addressCountry: CountryCode.SouthAfrica,
};
